module.exports = __webpack_public_path__ + "static/media/rundkolben_frage.86fe4eed.jpg";